// import { useMemo } from 'react'
import { Interface } from '@ethersproject/abi'
import { useLockContract } from '../hooks/useContract'
import ERC20_ABI from '../constants/abis/erc20.json'
import { useSingleCallResult, useMultipleContractSingleData } from '../state/multicall/hooks'

export function Lock(lockAddress: string, owner?: string): any {
  const contract = useLockContract(lockAddress, false)
  
  const supportTokens = useSingleCallResult(contract, 'getApplyTokens', []).result
  // eslint-disable-next-line no-console
  console.log(supportTokens, "supportTokens---")
  const tokens = supportTokens?.tokenArr || []

   const addressArr:Array<any> = []
   const tokenArr = tokens.map((item:any) => {
      addressArr.push(owner)
      return item.tokenAddress
    })
  
  const balances:any =  useMultipleContractSingleData(tokenArr, new Interface(ERC20_ABI), 'balanceOf', [owner])

  const allowances:any =  useMultipleContractSingleData(tokenArr, new Interface(ERC20_ABI), 'allowance', [owner, lockAddress])

  const userSupportTokens:Array<any> = []
  
  balances.forEach((item:any, index:number) => {
    if(item && item.result && allowances[index].result) {
      userSupportTokens.push({balance: item.result.balance.toString(), allowance: allowances[index].result[0].toString(), ...tokens[index]}) 
    }
  });

   const userLocks:Array<any> = []
   const userLockInfosRes:any = useSingleCallResult(contract, 'getUserLockInfos', [owner]).result
   const userLockInfos = userLockInfosRes?.lockInfos || []

   const userLockTokensRes:any = useSingleCallResult(contract, 'getUserLockTokens', [owner]).result
   const userLockTokens = userLockTokensRes?.tokens || []

   userLockTokens.forEach((item: any, index: number) => {
      userLocks.push({...item, amount:  userLockInfos[index].tokenAmount.toString()})
   });
  // eslint-disable-next-line no-console
  console.log(userLocks, "userLocks---")
    const userInfoRes:any = useSingleCallResult(contract, 'userInfo', [owner]).result
    const userInfo:any = userInfoRes ? {
      lastTime: userInfoRes.lastTime.toString(),
      reward: userInfoRes.reward.toString(),
      trueReward: userInfoRes.trueReward.toString()
    } : null
    const totalRewardRes = useSingleCallResult(contract, 'getTotalReward', [owner]).result
    const rewardRes = useSingleCallResult(contract, 'getReward', [owner]).result
    
    const totalReward = totalRewardRes ? totalRewardRes?.total.toString() : '0'
    const reward = rewardRes ? rewardRes?._reward.toString() : '0'

    const lockTimeRes = useSingleCallResult(contract, 'lockTime').result
    const lockTime = lockTimeRes ? lockTimeRes[0].toString() : '0'

    const userLockAmountRes:any = useSingleCallResult(contract, 'getUserLock', [owner]).result
    const userLockAmount = userLockAmountRes ? userLockAmountRes?.lockAmount.toString() : '0.000'

   return {
    userInfo,
    userLocks,
    userSupportTokens,
    totalReward,
    reward,
    lockTime,
    userLockAmount
   }
}

export default Lock
